// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const ChartSettingsWidgetListHeader = styled.h4`
  margin-left: 2rem;
  margin-bottom: 1rem;
  color: var(--mb-color-bg-dark);
  text-transform: uppercase;
`;

export const ChartSettingsWidgetListDivider = styled.div`
  background-color: var(--mb-color-border);
  height: 1px;
  display: block;
  margin-bottom: 1.5rem;
  margin-left: 2rem;
  margin-right: 2rem;
`;
